import { render, staticRenderFns } from "./ResendSentChannel.vue?vue&type=template&id=19282a2c&"
import script from "./ResendSentChannel.vue?vue&type=script&lang=js&"
export * from "./ResendSentChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19282a2c')) {
      api.createRecord('19282a2c', component.options)
    } else {
      api.reload('19282a2c', component.options)
    }
    module.hot.accept("./ResendSentChannel.vue?vue&type=template&id=19282a2c&", function () {
      api.rerender('19282a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/ResendSentChannel.vue"
export default component.exports